var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvaluationResponse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14.488,
    viewBox: "0 0 16 14.488",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5966",
    "data-name": "Group 5966",
    transform: "translate(-13617.431 -21632)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun-chat-1477091",
    transform: "translate(13617.431 21632)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5941",
    "data-name": "Path 5941",
    d: "M122.962,62.5a2.58,2.58,0,0,0-2.581-2.581H109.543a2.58,2.58,0,0,0-2.581,2.581v5.972a2.581,2.581,0,0,0,2.581,2.581h2.931v2.986a.369.369,0,0,0,.2.332l.166.037h0a.369.369,0,0,0,.221-.074l4.147-3.281h3.171a2.581,2.581,0,0,0,2.581-2.581Zm-.737,5.972a1.843,1.843,0,0,1-1.843,1.843h-3.3a.369.369,0,0,0-.221.074l-3.65,2.894V70.7a.369.369,0,0,0-.369-.369h-3.3a1.843,1.843,0,0,1-1.843-1.843V62.5a1.843,1.843,0,0,1,1.843-1.843h10.839a1.843,1.843,0,0,1,1.843,1.843Z",
    transform: "translate(-106.962 -59.921)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5942",
    "data-name": "Path 5942",
    d: "M166.311,180.88a1.671,1.671,0,1,0,1.181.489A1.671,1.671,0,0,0,166.311,180.88Zm0,2.59a.92.92,0,1,1,.65-.269A.919.919,0,0,1,166.311,183.47Z",
    transform: "translate(-162.707 -176.92)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5943",
    "data-name": "Path 5943",
    d: "M301.831,180.88a1.671,1.671,0,1,0,1.181.489A1.671,1.671,0,0,0,301.831,180.88Zm0,2.59a.92.92,0,1,1,.65-.269A.919.919,0,0,1,301.831,183.47Z",
    transform: "translate(-293.831 -176.92)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5944",
    "data-name": "Path 5944",
    d: "M437.351,180.88a1.671,1.671,0,1,0,1.181.489A1.671,1.671,0,0,0,437.351,180.88Zm0,2.59a.92.92,0,1,1,.65-.269A.919.919,0,0,1,437.351,183.47Z",
    transform: "translate(-424.955 -176.92)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluationResponse);
export default __webpack_public_path__ + "static/media/evaluationResponse.dde463987d2c6c689d7d2dc54d5f4892.svg";
export { ForwardRef as ReactComponent };